import React, { Component } from 'react';
import { mergeStyles } from 'react-select';
import makeAnimated from 'react-select/animated';
import memoizeOne from 'memoize-one';
import isEqual from 'react-fast-compare';
import * as defaultComponents from './components';
import baseStyles from './styles';
export default function createSelect(WrappedComponent) {
    var _a;
    return _a = class AtlaskitSelect extends Component {
            constructor(props) {
                super(props);
                this.components = {};
                this.select = null;
                this.cacheComponents = (components, enableAnimation) => {
                    this.components = enableAnimation
                        ? makeAnimated({
                            ...defaultComponents,
                            ...components,
                        })
                        : {
                            ...defaultComponents,
                            ...components,
                        };
                };
                this.onSelectRef = (ref) => {
                    this.select = ref;
                    const { innerRef } = this.props;
                    if (typeof innerRef === 'object') {
                        innerRef.current = ref;
                    }
                    if (typeof innerRef === 'function') {
                        innerRef(ref);
                    }
                };
                this.cacheComponents = memoizeOne(this.cacheComponents, isEqual).bind(this);
                this.cacheComponents(props.components || {}, props.enableAnimation);
            }
            UNSAFE_componentWillReceiveProps(nextProps) {
                this.cacheComponents(nextProps.components, nextProps.enableAnimation);
            }
            focus() {
                if (this.select)
                    this.select.focus();
            }
            blur() {
                if (this.select)
                    this.select.blur();
            }
            render() {
                const { styles, validationState, spacing, isMulti, ...props } = this.props;
                const isCompact = spacing === 'compact';
                // props must be spread first to stop `components` being overridden
                return (React.createElement(WrappedComponent, Object.assign({ ref: this.onSelectRef, isMulti: isMulti }, props, { components: this.components, styles: mergeStyles(baseStyles(validationState, isCompact), styles) })));
            }
        },
        _a.defaultProps = {
            enableAnimation: true,
            validationState: 'default',
            spacing: 'default',
            onClickPreventDefault: true,
            tabSelectsValue: false,
            components: {},
            styles: {},
        },
        _a;
}
//# sourceMappingURL=createSelect.js.map